import { useEffect, useMemo } from 'react'
import { AppModule } from '@core/modules/app/app.module'
import { AssetsModule } from '@core/modules/digital-footprint/assets'
import { DOMAIN_ASSET_TYPES } from '@core/modules/digital-footprint/assets/constants'
import { unifiedDomainsFilterModule } from '@core/modules/digital-footprint/assets/domains.filters'
import { DomainsModule } from '@core/modules/domains/domains.module'
import { DialogService } from '@core/services/dialog'

export const useDomainsPage = () => {
    const { loading, data: allAssets } = AssetsModule.useStore()
    const { filter, search } = unifiedDomainsFilterModule.useStore()

    const domainAssets = useMemo(() => {
        return allAssets.filter((a) => DOMAIN_ASSET_TYPES.includes(a.asset_type))
    }, [allAssets])

    const filteredAssets = useMemo(() => {
        return unifiedDomainsFilterModule.processData(domainAssets, false)
    }, [domainAssets, filter, search])

    const domains = DomainsModule.getAcceptedDomainsWithSubscription()
    const { scanInProgress } = AppModule.useStore()

    const emptyAssetsMessage =
        domains.length > 0
            ? 'No domains available for the current search and filter settings'
            : 'No Domain found, please add a domain'

    useEffect(() => {
        return () => {
            DialogService.hideDialog('asset-details-dialog').catch(
                console.error
            )
        }
    }, [])

    return {
        loading,
        filteredAssets,
        scanInProgress,
        emptyAssetsMessage,
    }
}
